export default __webpack_public_path__ + "static/media/Categories.dc508b1f.webp";